import { forwardRef } from "react";
import { ActionIcon } from "../../action-icon";
import { Icon } from "../../icon";
import { Tooltip } from "../../tooltip";
import type { IProps } from "./auto-table-row-action.types";

/**
 * An icon button for an AutoTable row, rendered by the table's `rowActions` prop. Shows `label` as a tooltip.
 * Forwards its ref and props to the button, so it can be used as a menu target.
 * @param {IconDefinition} props.icon - Icon shown in the button.
 * @param {string} props.label - Tooltip and accessible name of the button.
 * @returns {JSX.Element} The AutoTableRowAction component.
 */
const AutoTableRowAction = forwardRef<HTMLButtonElement, IProps>(({ icon, label, ...otherProps }, ref) => (
    <Tooltip label={label}>
        <ActionIcon ref={ref} variant="default" size="input-xs" aria-label={label} {...otherProps}>
            <Icon icon={icon} size="sm" />
        </ActionIcon>
    </Tooltip>
));

AutoTableRowAction.displayName = "AutoTableRowAction";

export { AutoTableRowAction };
